var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FB7B34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2929 16.2929C13.6834 15.9024 14.3166 15.9024 14.7071 16.2929L20 21.5858L25.2929 16.2929C25.6834 15.9024 26.3166 15.9024 26.7071 16.2929C27.0976 16.6834 27.0976 17.3166 26.7071 17.7071L20.7071 23.7071C20.3166 24.0976 19.6834 24.0976 19.2929 23.7071L13.2929 17.7071C12.9024 17.3166 12.9024 16.6834 13.2929 16.2929Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectInputIcon);
export default __webpack_public_path__ + "static/media/select-input-icon.358760724b600e731c81cba8c067244b.svg";
export { ForwardRef as ReactComponent };